import React, { useState, useEffect, Component } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import NumberFormat from "react-number-format";
//import axios from "axios";
import axiosInstance from "./../../helpers/axiosInstance";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Skeleton from "react-loading-skeleton";
import iconDetails from '../../assets/img/icons/Icono-Detalles-Blanco.png'
import iconTransfer from '../../assets/img/icons/Icono-Transferencia-Blanco.png'
import iconPay from '../../assets/img/icons/Icono-Pago-Interno-Blanco.png'
import iconProyect from '../../assets/img/icons/Icono-Deuda-Blanco.png'
import { useDispatch, useSelector } from 'react-redux';
import { cambiavalorpago, actualizarCheckboxs, actualizaropcionpago, actualizarBotonPagar } from 'Silicerreducerpayu';

// reactstrap components
import {
  Card,
  Button,
  NavLink,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  CardTitle,
  UncontrolledTooltip,
} from "reactstrap";

const Botonrapido=(props)=>{
    const dispatch = useDispatch()
    var icon =props.icon,
    iconactiv=props.iconactiv,
    title =props.title
    const [iconestado,seticonestado]=useState(icon);
    const [textoestado,settextoestado]=useState("text-grissantander mb-0")
    const mousehover=(estado)=>{
      if(estado=="activo"){
        seticonestado(iconactiv);
        settextoestado("text-green mb-0")

      }else{
        seticonestado(icon);
        settextoestado("text-grissantander mb-0")

      }
    }

    const habilitarBoton = () => {
      dispatch(actualizarBotonPagar(false))
    }

    return(
          <div  onClick={() => habilitarBoton()} onMouseOver={()=>{mousehover("activo")}} onMouseOut={()=>{mousehover("desactivado")}} className="card-fast-actions bg-white" style={{"max-width":"100%",width:"80px"}}>
            <CardBody style={{"padding":"1em"}}>
                <Row className="align-items-center"style={{"paddingLeft":"6px"}}>
                  <Col className="col-auto">
                      <div className="icon icon-shape text-white rounded-circle shadow" style={{width:"40px",height:"40px"}}>
                      {/*<i className={icon} />*/}
                      <i><img style={{height:"40px", }} src={iconestado}></img></i>
                      </div>
                  </Col>
                  <div className="col ">
                      <CardTitle
                      tag="h5"
                      className={textoestado}
                      style={{fontSize:"10px"}}
                      >
                      {title}
                      </CardTitle>
                  </div>
                </Row>
            </CardBody>
        </div>
    )
}

export default Botonrapido;